/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Ai_GenerateInputs */

const en_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const de_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const fr_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const es_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const it_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const nl_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const pl_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const fi_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const da_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

const sv_story_bank_ai_generate = /** @type {(inputs: Story_Bank_Ai_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Generate`)
};

/**
* | output |
* | --- |
* | "AI Generate" |
*
* @param {Story_Bank_Ai_GenerateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_ai_generate = /** @type {((inputs?: Story_Bank_Ai_GenerateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Ai_GenerateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_ai_generate(inputs)
	if (locale === "fr") return fr_story_bank_ai_generate(inputs)
	if (locale === "es") return es_story_bank_ai_generate(inputs)
	if (locale === "it") return it_story_bank_ai_generate(inputs)
	if (locale === "nl") return nl_story_bank_ai_generate(inputs)
	if (locale === "pl") return pl_story_bank_ai_generate(inputs)
	if (locale === "fi") return fi_story_bank_ai_generate(inputs)
	if (locale === "da") return da_story_bank_ai_generate(inputs)
	if (locale === "sv") return sv_story_bank_ai_generate(inputs)
	return en_story_bank_ai_generate(inputs)
});